import useMyStore from "../Global";

const usePermission = () => {

  const user = useMyStore((state) => state.user);


  const hasPermission = (label, action) => {
    const permission = user?.perms?.find((perm) => perm.label === label);
    return permission ? permission[action] : false;
  };

  return {
    hasPermission
  }
}

export default usePermission